module.exports = __webpack_public_path__ + "static/media/Rss-feed-01.536fd8ff.svg";